import { render, staticRenderFns } from "./DicionarioDados.vue?vue&type=template&id=0a2053b8"
import script from "./DicionarioDados.vue?vue&type=script&lang=js"
export * from "./DicionarioDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports